/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetCompositionsDetailByIdQueryResponse, GetCompositionsDetailByIdPathParams } from "../models/GetCompositionsDetailById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getCompositionsDetailById } from "../axios/getCompositionsDetailById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getCompositionsDetailByIdQueryKey = (id: GetCompositionsDetailByIdPathParams["id"]) => ["web-app-bff-api", { url: '/compositions/:id', params: {id:id} }] as const

export type GetCompositionsDetailByIdQueryKey = ReturnType<typeof getCompositionsDetailByIdQueryKey>

export function getCompositionsDetailByIdQueryOptions(id: GetCompositionsDetailByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getCompositionsDetailByIdQueryKey(id)
        return queryOptions<GetCompositionsDetailByIdQueryResponse, ResponseErrorConfig<Error>, GetCompositionsDetailByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getCompositionsDetailById(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get one composition by id
 * {@link /compositions/:id}
 */
export function useGetCompositionsDetailById<TData = GetCompositionsDetailByIdQueryResponse, TQueryData = GetCompositionsDetailByIdQueryResponse, TQueryKey extends QueryKey = GetCompositionsDetailByIdQueryKey>(id: GetCompositionsDetailByIdPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetCompositionsDetailByIdQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getCompositionsDetailByIdQueryKey(id)
         

         const query = useQuery({
          ...getCompositionsDetailByIdQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}